/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

/*
 * Reading text out of map content.
 *
 * Content fields are either a plain string or a `{lang: text}` mapping, and
 * a miss must never render as nothing.
 */

/**
 *
 * @param {Object<string, string> | string | null} value
 * @param {string} language
 * @returns {string}
 */
export const translate = (value, language) => {
    if (value !== null && typeof value === 'object') {
        return value[language] || '';
    } else {
        return value || '';
    }
};

/**
 * Strip all HTML tags from a string.
 * @param {string} html
 * @returns {string}
 */
export const stripHTML = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return tmp.textContent || '';
};
